import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

const groupService = {
  list: async () => {
    const response = await api.get(API_ENDPOINTS.GROUPS.LIST);
    return response.data;
  },
  get: async (id) => {
    const response = await api.get(API_ENDPOINTS.GROUPS.DETAIL(id));
    return response.data;
  },
  create: async (name) => {
    const response = await api.post(API_ENDPOINTS.GROUPS.LIST, { name });
    return response.data;
  },
  update: async (id, name) => {
    const response = await api.patch(API_ENDPOINTS.GROUPS.DETAIL(id), { name });
    return response.data;
  },
  delete: async (id) => {
    await api.delete(API_ENDPOINTS.GROUPS.DETAIL(id));
  },
  addProperties: async (id, propertyIds) => {
    const response = await api.post(API_ENDPOINTS.GROUPS.PROPERTIES(id), {
      property_ids: propertyIds,
    });
    return response.data;
  },
  removeProperty: async (id, propertyId) => {
    await api.delete(API_ENDPOINTS.GROUPS.PROPERTY_DETAIL(id, propertyId));
  },
};

export default groupService;
